import {
    PollDetailsStack,
    PollOptionStack,
    ResponderAvatar,
} from "../PostPollOptions.styles";
import { AvatarGroup, SxProps, Typography } from "@mui/material";
import { TEXT_ELLIPSIS } from "../../../../Shared/styles";
import userAvatarChecker from "../../../../Shared/UserAvatarChecker";
import { prepareAvatarContent } from "../../../UserAvatar/UserAvatarFactory";
import { avatarFallbackColorSelector } from "../../../../Shared/Avatar/AvatarFallbackColorSelector";
import { PollOption } from "@infrastructure/Services/PostService.types";
import { useUserSimplifiedStore } from "@infrastructure/Persistence/useUserSimplifiedStore";
import { useUserProfile } from "@infrastructure/Persistence/UserProfileState";
import { ReactNode } from "react";

export function PostPollTextOption({
    enableVoting,
    handlePollOptionClick,
    icon,
    isRespondedByCurrentUser,
    optionPercentage,
    pollOption,
    showDetails,
    sx,
}: {
    enableVoting: boolean;
    handlePollOptionClick: (
        pollOptionId: number,
        type: "create" | "delete",
    ) => void;
    icon: ReactNode;
    isRespondedByCurrentUser: boolean;
    optionPercentage: number;
    pollOption: PollOption;
    showDetails: boolean;
    sx?: SxProps;
}) {
    const { userId } = useUserSimplifiedStore();
    const { avatar } = useUserProfile();

    const respondersWithoutHighlightedCount =
        pollOption.responsesCount - pollOption.responseHighlights.length;

    return (
        <PollOptionStack
            onClick={() => {
                enableVoting &&
                    handlePollOptionClick(
                        pollOption.id,
                        isRespondedByCurrentUser ? "delete" : "create",
                    );
            }}
            userVoted={isRespondedByCurrentUser}
            direction={"row"}
            backgroundColorPercentage={
                showDetails ? optionPercentage : undefined
            }
            pollIsActive={enableVoting}
            sx={sx}
        >
            {icon}
            <Typography
                style={{
                    flex: 1,
                    fontSize: "14px",
                }}
            >
                {pollOption.content}
            </Typography>
            {showDetails && (
                <PollDetailsStack>
                    {optionPercentage > 0 && (
                        <Typography
                            style={{
                                flex: 1,
                                fontSize: "14px",
                                fontWeight: "700",
                                color: "var(--community-color-primary-text)",
                                ...TEXT_ELLIPSIS,
                            }}
                        >
                            {optionPercentage}%
                        </Typography>
                    )}
                    <AvatarGroup
                        max={2}
                        sx={{
                            "& .MuiAvatar-root": {
                                marginLeft: "-10px",
                                border: "1px solid var(--community-color-snow-white) !important",
                                boxShadow: "none",
                            },
                        }}
                    >
                        {pollOption.responseHighlights.map((response, key) => (
                            <ResponderAvatar
                                key={`participant-${key}`}
                                src={
                                    response.avatar ||
                                    (response.uuid == userId && avatar) ||
                                    undefined
                                }
                                onError={() =>
                                    userAvatarChecker(
                                        response.avatar,
                                        response.uuid,
                                    )
                                }
                            >
                                {prepareAvatarContent(
                                    avatarFallbackColorSelector(response.uuid),
                                    response.gender,
                                )}
                            </ResponderAvatar>
                        ))}
                    </AvatarGroup>
                    {respondersWithoutHighlightedCount > 0 && (
                        <Typography
                            style={{
                                fontSize: "14px",
                                ...TEXT_ELLIPSIS,
                            }}
                        >
                            {`+${respondersWithoutHighlightedCount.toLocaleString(
                                "de-DE",
                            )}`}
                        </Typography>
                    )}
                </PollDetailsStack>
            )}
        </PollOptionStack>
    );
}
